import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {RegisterLandingPageComponent} from './register-landing-page/register-landing-page.component';

const routes: Routes = [
    {
        path: '',
        component: RegisterLandingPageComponent
    },
    {
        path: 'subscribe',
        component: RegisterLandingPageComponent
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class RegistrationRoutingModule {
}
